import { jobActionTypes } from 'store/actionTypes';

const initialState = {
  isLoading: false,
  job: null,
  error: null,
  inquiryValidationErrors: [],
  searchReportValidationErrors: [],
  quoteValidationErrors: [],
  jobs: [],
  searchReportJobs: [],
};

const jobReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case jobActionTypes.GET_JOB_BY_ID_START:
    case jobActionTypes.SEND_JOB_INQUIRY_START:
    case jobActionTypes.UPDATE_JOB_INQUIRY_START:
    case jobActionTypes.UPDATE_JOB_SEARCH_REPORT_START:
    case jobActionTypes.ADD_JOB_INQUIRY_ROWS_START:
    case jobActionTypes.ADD_JOB_SEARCH_REPORT_ROWS_START:
    case jobActionTypes.GET_ALL_JOBS_START:
    case jobActionTypes.CREATE_NEW_JOB_START:
    case jobActionTypes.GET_SEARCH_REPORT_JOBS_START:
    case jobActionTypes.ASSIGN_EMPLOYEES_TO_JOB_START:
    case jobActionTypes.ADD_TO_PRODUCT_START:
    case jobActionTypes.SEND_TO_CLIENT_START:
    case jobActionTypes.DELETE_JOB_SEARCH_REPORT_ROWS_START:
    case jobActionTypes.DELETE_JOB_INQUIRY_ROWS_START:
    case jobActionTypes.CREATE_QUOTE_START:
    case jobActionTypes.ADD_JOB_QUOTE_ROWS_START:
    case jobActionTypes.DELETE_JOB_QUOTE_ROWS_START:
    case jobActionTypes.SEND_JOB_QUOTE_START:
    case jobActionTypes.UPDATE_JOB_QUOTE_START:
    case jobActionTypes.DELETE_JOB_INQUIRY_START:
    case jobActionTypes.CHANGE_JOB_INQUIRY_START:
    case jobActionTypes.CHANGE_JOB_SEARCH_REPORT_START:
    case jobActionTypes.CHANGE_JOB_QUOTE_START:
    case jobActionTypes.DUPLICATE_JOB_INQUIRY_ROWS_START:
    case jobActionTypes.DUPLICATE_JOB_SEARCH_REPORT_ROWS_START:
    case jobActionTypes.DUPLICATE_JOB_QUOTE_ROWS_START:
    case jobActionTypes.SUBMIT_JOB_INQUIRY_START:
      return {
        ...state,
        isLoading: true,
      };
    case jobActionTypes.GET_JOB_BY_ID:
    case jobActionTypes.SEND_JOB_INQUIRY:
    case jobActionTypes.UPDATE_JOB_INQUIRY:
    case jobActionTypes.UPDATE_JOB_SEARCH_REPORT:
    case jobActionTypes.ADD_JOB_INQUIRY_ROWS:
    case jobActionTypes.ADD_JOB_SEARCH_REPORT_ROWS:
    case jobActionTypes.ADD_TO_PRODUCT:
    case jobActionTypes.SEND_TO_CLIENT:
    case jobActionTypes.CREATE_QUOTE:
    case jobActionTypes.ADD_JOB_QUOTE_ROWS:
    case jobActionTypes.SEND_JOB_QUOTE:
    case jobActionTypes.UPDATE_JOB_QUOTE:
    case jobActionTypes.DUPLICATE_JOB_INQUIRY_ROWS:
    case jobActionTypes.DUPLICATE_JOB_SEARCH_REPORT_ROWS:
    case jobActionTypes.DUPLICATE_JOB_QUOTE_ROWS:
      return {
        ...state,
        job: payload,
        isLoading: false,
        error: null,
      };
    case jobActionTypes.CHANGE_JOB_INQUIRY:
      return {
        ...state,
        isLoading: false,
        inquiryValidationErrors: [],
        error: null,
      };
    case jobActionTypes.CHANGE_JOB_SEARCH_REPORT:
      return {
        ...state,
        isLoading: false,
        searchReportValidationErrors: [],
        error: null,
      };
    case jobActionTypes.CHANGE_JOB_QUOTE:
      return {
        ...state,
        isLoading: false,
        quoteValidationErrors: [],
        error: null,
      };
    case jobActionTypes.DELETE_JOB_INQUIRY:
    case jobActionTypes.SUBMIT_JOB_INQUIRY:
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case jobActionTypes.ASSIGN_EMPLOYEES_TO_JOB:
      const jobIndex = state.jobs.findIndex(j => j.ID === payload.ID);
      const copy = [...state.jobs];
      copy[jobIndex] = payload;
      return {
        ...state,
        jobs: copy,
        isLoading: false,
        error: null,
      };
    case jobActionTypes.CREATE_NEW_JOB:
      const jobsCopy = [...state.jobs];
      jobsCopy.push(payload);
      return {
        ...state,
        jobs: jobsCopy,
        isLoading: false,
        error: null,
      };
    case jobActionTypes.RESET_JOB:
      return {
        ...state,
        job: null,
      };
    case jobActionTypes.DELETE_JOB_INQUIRY_ROWS:
      const newInquiryPayload = state.job.inquiry_payload.filter(
        row => !payload.includes(row.row_id),
      );
      return {
        ...state,
        isLoading: false,
        error: null,
        job: {
          ...state.job,
          inquiry_payload: newInquiryPayload,
        },
      };
    case jobActionTypes.DELETE_JOB_QUOTE_ROWS:
      const newQuotePayload = state.job.quote_payload.filter(
        row => !payload.includes(row.row_id),
      );
      return {
        ...state,
        isLoading: false,
        error: null,
        job: {
          ...state.job,
          quote_payload: newQuotePayload,
        },
      };
    case jobActionTypes.DELETE_JOB_SEARCH_REPORT_ROWS:
      const newSearchPayload = state.job.search_report_payload.filter(
        row => !payload.includes(row.row_id),
      );
      return {
        ...state,
        isLoading: false,
        error: null,
        job: {
          ...state.job,
          search_report_payload: newSearchPayload,
        },
      };
    case jobActionTypes.GET_ALL_JOBS:
      return {
        ...state,
        jobs: payload,
        isLoading: false,
        error: null,
      };
    case jobActionTypes.GET_SEARCH_REPORT_JOBS:
      return {
        ...state,
        searchReportJobs: payload,
        isLoading: false,
        error: null,
      };
    case jobActionTypes.CHANGE_JOB_INQUIRY_VALIDATION_ERROR:
      return {
        ...state,
        isLoading: false,
        inquiryValidationErrors: payload,
      };
    case jobActionTypes.CHANGE_JOB_SEARCH_REPORT_VALIDATION_ERROR:
      return {
        ...state,
        isLoading: false,
        searchReportValidationErrors: payload,
      };
    case jobActionTypes.CHANGE_JOB_QUOTE_VALIDATION_ERROR:
      return {
        ...state,
        isLoading: false,
        quoteValidationErrors: payload,
      };
    case jobActionTypes.GET_JOB_BY_ID_ERROR:
    case jobActionTypes.SEND_JOB_INQUIRY_ERROR:
    case jobActionTypes.UPDATE_JOB_INQUIRY_ERROR:
    case jobActionTypes.UPDATE_JOB_SEARCH_REPORT_ERROR:
    case jobActionTypes.ADD_JOB_INQUIRY_ROWS_ERROR:
    case jobActionTypes.ADD_JOB_SEARCH_REPORT_ROWS_ERROR:
    case jobActionTypes.GET_ALL_JOBS_ERROR:
    case jobActionTypes.CREATE_NEW_JOB_ERROR:
    case jobActionTypes.GET_SEARCH_REPORT_JOBS_ERROR:
    case jobActionTypes.ASSIGN_EMPLOYEES_TO_JOB_ERROR:
    case jobActionTypes.ADD_TO_PRODUCT_ERROR:
    case jobActionTypes.SEND_TO_CLIENT_ERROR:
    case jobActionTypes.DELETE_JOB_SEARCH_REPORT_ROWS_ERROR:
    case jobActionTypes.DELETE_JOB_INQUIRY_ROWS_ERROR:
    case jobActionTypes.CREATE_QUOTE_ERROR:
    case jobActionTypes.ADD_JOB_QUOTE_ROWS_ERROR:
    case jobActionTypes.DELETE_JOB_QUOTE_ROWS_ERROR:
    case jobActionTypes.SEND_JOB_QUOTE_ERROR:
    case jobActionTypes.UPDATE_JOB_QUOTE_ERROR:
    case jobActionTypes.DELETE_JOB_INQUIRY_ERROR:
    case jobActionTypes.CHANGE_JOB_INQUIRY_ERROR:
    case jobActionTypes.CHANGE_JOB_SEARCH_REPORT_ERROR:
    case jobActionTypes.CHANGE_JOB_QUOTE_ERROR:
    case jobActionTypes.DUPLICATE_JOB_INQUIRY_ROWS_ERROR:
    case jobActionTypes.DUPLICATE_JOB_SEARCH_REPORT_ROWS_ERROR:
    case jobActionTypes.DUPLICATE_JOB_QUOTE_ROWS_ERROR:
    case jobActionTypes.SUBMIT_JOB_INQUIRY_ERROR:
      return {
        ...state,
        error: payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default jobReducer;
